

define(['angular', 'squid/index'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-unified-login.kmliUpsell', ['squid']).factory('$KmliUpsell', function ($pxp, $CheckoutAppDataModel, $config, $populate, $q) {

        var pxpTreatment;
        var idToken;
        var kmliEligible;
        var successfulLogin;
        var kmliChecked;
        var upsellOptInDisplayed;
        var showReactivationInterstitial;

        return {

            init: function init(upsellEligibilityData) {
                if (upsellEligibilityData) {
                    idToken = Boolean(upsellEligibilityData.idToken);
                    successfulLogin = upsellEligibilityData.ulData && upsellEligibilityData.ulData.event === 'loginSuccess';
                    kmliEligible = upsellEligibilityData.kmliEligible;
                    kmliChecked = upsellEligibilityData.ulData && upsellEligibilityData.ulData.keepMeLoggedIn === true;
                    upsellOptInDisplayed = upsellEligibilityData.upsellOptInDisplayed;
                    showReactivationInterstitial = upsellEligibilityData.showReactivationInterstitial === true;
                }
            },

            eligible: function eligible(token) {

                var $scope = {};

                if (showReactivationInterstitial && !kmliChecked && kmliEligible && idToken) {
                    return $q(function (resolve, reject) {
                        resolve({ eligible: true, type: 'reactivation' });
                    });
                } else {
                    return $populate($scope, {
                        checkoutAppData: $CheckoutAppDataModel.instance(token)
                    }).then(function () {
                        var merchantCountry = $scope.checkoutAppData.merchant.merchant_country;
                        return $pxp($config.ulMeta.pxpExpId, { 'ctx.COUNTRY': merchantCountry }, 'xo_hermes_kmli_upsell_(web|mobile)_treatment');
                    }).then(function (result) {
                        pxpTreatment = Boolean(result);
                        if (Boolean(pxpTreatment && idToken && kmliEligible && successfulLogin && !kmliChecked && !upsellOptInDisplayed)) {
                            return { eligible: true, type: 'member' };
                        } else {
                            return { eligible: false };
                        }
                    });
                }
            },

            getOptions: function getOptions() {

                if (showReactivationInterstitial) {
                    return {
                        flowName: 'expiredUpsell'
                    };
                }
            },

            getFPTIAttributes: function getFPTIAttributes() {

                if (showReactivationInterstitial) {
                    return {
                        stateName: 'KMLI_reactivation',
                        transInfix: '_kmli_reactivation_'
                    };
                } else {
                    return {
                        stateName: 'KMLI_UPSELL',
                        transInfix: '_kmli_upsell_'
                    };
                }
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js
 ** module id = 204
 ** module chunks = 1
 **/